const theme = {
  colors: {
    background: "#F5FAFF",
    primary: "#1A3C6F",
    secondary: "#326297",
    hover: "#f0f0f0",
    header: "white",
    headerText: "#222",
    headerSubText: "#444",
    footer: "#1A3C6F",
    footerText: "white",
    homeOverlay: "rgba(0,0,0,0.3)",
    overlay: "rgba(0,0,0,0.7)",
    shadow: "rgba(0, 0, 0, 0.1)",
    shadowHover: "rgba(0, 0, 0, 0.15)",
    border: "rgba(0, 0, 0, 0.1)",
    black: "#222",
  },
  breakpoints: {
    tablet: "1024px",
    mobile: "480px",
  },
};

export default theme;
